// import { ui } from '@/api';
// import get from 'lodash.get';
// import services from '@/services/index';
import { useDeviceStore } from '@/stores/Device.store';

export default function deviceServiceFactory(services) {
  // We are no longer overriding here...Separate images should be created for each model so that Mobile client can resolve images
  // 'image' field in devices.json should match the 'model' field (at least for now)
  const imageKeyOverrides = {};

  let deviceStore;

  return {
    init,
    getDevices,
    getInstructions,
    getTemplate,
    getDevicesAsync,
    getDeviceAsync,
    getImagePath,
    getModelName,
    getTypeName,
    getGroupName,
    getModels,
    getModel,
    hasFeature,
    hasFeatureByDevice,
    hasFeatureByModel,
    addDeviceAsync,
    updateDeviceAsync,
    updateDcsDeviceAsync,
    deleteDeviceAsync,
    getDeviceGroups,
  };

  ////////////////////

  function init() {
    deviceStore = useDeviceStore();
  }

  function getDevices() {
    return deviceStore.devices;
  }

  function getInstructions(id) {
    let cc = services.session.getClientConfig();
    let instructions = cc.devices?.instructions ? cc.devices.instructions : [];

    return instructions[id];
  }

  function getModels() {
    if (deviceStore.hasModels()) {
      return deviceStore.models;
    }

    let cc = services.session.getClientConfig();
    let typesAndModels = cc.devices?.types ? cc.devices.types : [];
    let models = [];
    for (const [t, list] of Object.entries(typesAndModels)) {
      list.forEach(m => {
        m.ui = {
          modelDisplay: services.i18n.$t(`devices.${m.modelName.replace(/ /g, '_')}`),
          typeDisplay: services.i18n.$t(`devices.${m.deviceType.replace(/ /g, '_')}`),
          image: getImagePath(m.modelName),
          scaledImage: getImagePath(m.modelName, true),
        }

        models.push(m);
      });
    }

    deviceStore.setModels(models);

    return models;
  }

  function getModel(type, model) {
    let models = getModels();
    return models.find(m => {
      return m.deviceType === type && m.modelName === model;
    })
  }

  function getTemplate(aaaModel) {
    let cc = services.session.getClientConfig();
    let templates = cc.devices?.templates ? cc.devices.templates : [];

   return templates.find(t => {
      return t.type === aaaModel.deviceType && t.model === aaaModel.modelName;
    });
  }

  function addDeviceAsync(device) {
    return services.http.post('aaa', 'organizations/devices', device, {version:4}).then(resp => {
      let addedDevice = resp.data.device;
      setupDevice(addedDevice, services.session.getContext());
      let devices = deviceStore.devices;
      if (!devices.find(d => { return d.deviceId === resp.deviceId})) {
        devices.push(addedDevice);
        deviceStore.setDevices(devices);
      }
      return addedDevice;
    });
  }

  function deleteDeviceAsync(deviceId) {
    return services.http.delete('aaa', `organizations/devices/${deviceId}`, {version:4}).then(() => {
      deviceStore.deleteDevice(deviceId);
    });
  }

  function getDeviceGroups() {
    return deviceStore.groups;
  }

  function updateDeviceAsync(device) {
    return services.http.put('aaa', `organizations/devices/${device.deviceId}`, device, {version:4}).then(resp => {
      let updatedDevice = resp.data;
      setupDevice(updatedDevice, services.session.getContext());
      deviceStore.updateDevice(updatedDevice);
      return updatedDevice;
    }).catch(e => {
      console.log('Update Error', e);
    });
  }

  function updateDcsDeviceAsync(payload) {
    return services.http.put('dcs_service', `devices/${payload.device.deviceId}`, payload, {version:2}).then(resp => {
      let updatedDevice = resp.data;
      setupDevice(updatedDevice, services.session.getContext());
      deviceStore.updateDevice(updatedDevice);
      return updatedDevice;
    });
  }

  function getDevicesAsync(refresh = false) {
    if (!refresh && deviceStore.hasDevices()) {
      return Promise.resolve(deviceStore.devices);
    }

    return services.session.getClientConfigAsync(refresh).then(cc => {
      let devices = [];
      let deviceContexts = cc.devices?.list ? cc.devices.list : [];
      deviceContexts.forEach(dc => {
        dc.devices.forEach(d => {
          setupDevice(d, dc.context);
          devices.push(d);
        });
      });

      deviceStore.setDevices(devices);
      return devices;
    });
  }

  function getDeviceAsync(deviceId, refresh = false) {
    if (!refresh && deviceStore.hasDevices()) {
      return Promise.resolve(deviceStore.devices.find(d => { return d.deviceId === deviceId }));
    }

    return services.http.get('aaa', `organizations/devices/${deviceId}`, {version:4}).then(resp => {
      let updatedDevice = resp.data;
      setupDevice(updatedDevice, services.session.getContext);
      deviceStore.updateDevice(updatedDevice);
      return updatedDevice;
    });
  }

  function setupDevice(device, context) {
    device.context = context;
    if (!device.display) {
      device.display = {};
    }

    // TODO: Replace these with information from the device template
    device.display.model = getModelName(device.model);
    device.display.type = getTypeName(device.type);
    device.display.group = getGroupName(device.group);
    device.display.image = getImagePath(device.model);
    device.display.scaledImage = getImagePath(device.model, true);
    device.isInOrg = device.organizationId === context.id;
  }

  function getAllDevicesAsync(limit = 1000) {
    let devices = [];
    return _getDevicePage().then(resp => {
      let pageDevices = resp.data?.devices ? resp.data.devices : [];
      devices = devices.concat(pageDevices);

      let pages = Math.ceil(resp.data.total / limit);
      let promises = [];
      for (let p = 2; p < pages; p++) {
        promises.push(_getDevicePage(p, limit).then(pResp => {
          pageDevices = resp.data?.devices ? resp.data.devices : [];
          devices = devices.concat(pageDevices);
        }));
      }

      return Promise.all(promises).then(() => {
        deviceStore.setDevices(devices);
        return devices;
      })
    });
  }

  function _getDevicePage(page = 1, limit = 1000) {
    let offset = (page - 1) * limit;
    return services.http.get('aaa', 'organizations/devices/v2', {version:4, params: {limit, offset}}).then(resp => {
      let devicesWithContext = resp.data?.devicesWithContext ? resp.data.devicesWithContext : [];
      let myDevices = [];
      devicesWithContext.forEach(dwc => {
        myDevices = myDevices.concat(dwc.devices);
      });
      myDevices.forEach(d => {
        if (!d.display) {
          d.display = {};
        }

        d.display.model = getModelName(d.model);
        d.display.type = getTypeName(d.type);
        d.display.group = getGroupName(d.group);
        d.display.image = getImagePath(d.model);
        d.display.scaledImage = getImagePath(d.model, true);
      });

      return {
        data: {
          devices: myDevices,
          limit: resp.data.limit,
          offset: resp.data.offset,
          total: resp.data.total,
          unfilteredTotal: resp.data.unfilteredTotal,
        },
      };
    });
  }

  function getImagePath(model, scaled = false) {
    if (!model) {
      return null;
    }

    let modelKey = model.replace(/ /g, '_');
    let baseUrl = 'https://cdn.printos.com/images/devices/';
    baseUrl += scaled ? 'scaled' : 'general';
    const imageKey = imageKeyOverrides[modelKey] ? imageKeyOverrides[modelKey] : modelKey;
    return `${baseUrl}/${window.encodeURIComponent(imageKey)}.png`;
  }

  function getModelName(model) {
    if (!model) {
      return null;
    }

    let modelKey = model.replace(/ /g, '_');
    return services.i18n.$t(`devices.${modelKey}`);
  }

  function getTypeName(deviceType) {
    if (!deviceType) {
      return null;
    }

    let typeKey = deviceType.replace(/ /g, '_');
    return services.i18n.$t(`devices.${typeKey}`);
  }

  function getGroupName(group) {
    if (!group) {
      return null;
    }

    let typeKey = group.replace(/ /g, '_');
    return services.i18n.$t(`devices.Group_${typeKey}`);
  }

  function hasFeature(deviceId, feature) {
    let device = deviceStore.devices.find(d => { return d.deviceId === deviceId});
    if (!device) {
      return false;
    }

    return hasFeatureByModel(device.type, device.model, feature);
  }

  function hasFeatureByDevice(device, feature) {
    return hasFeatureByModel(device.type, device.model, feature);
  }

  function hasFeatureByModel(type, model, feature) {
    let cc = services.session.getClientConfig();
    let templates = cc.devices?.templates ? cc.devices.templates : [];

    let found = templates.find(t => {
      return t.type === type && t.model === model;
    });

    return found ? found.features.includes(feature) : false;
  }
}
